// @core/api/endpoints/team/reset_team_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResetTeamUISettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Reset team UI settings
 * Performs reset operation on team u i settings.
 */
export async function ResetTeamUISettings(
  team_id: string,
  data: ResetTeamUISettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/ui/reset`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
